/**
 * Cart Filler Recommendations v2.3
 * (v2.3) 드로어 추천 행 좌우 여백 + 푸터 위로 밀기(.mini-cart__main flex화) + "+" 버튼 배경 제거
 * (v2.2) 드로어 추천을 상품 목록(.mini-cart__main) 맨 아래로 — 푸터 비대화 해결
 * (v2.1) 헤딩 간결 + 속도 개선  (v2.0) 카드 미니멀  (v1.5) 빈 풀 캐싱 버그 수정
 */
(function () {
  'use strict';

  if (window.__bcCartFillerLoaded) return;
  window.__bcCartFillerLoaded = true;

  var CONFIG = {
    collectionHandle: 'cart-fillers',
    maxItems: 10,
    minRemaining: 0.01,
    rowId: 'bc-filler-row',
    debug: false
  };

  var i18nKo = document.documentElement.lang && document.documentElement.lang.indexOf('ko') === 0;
  var TEXT = {
    title: i18nKo ? '무료배송까지 조금만 더' : 'Add one for free shipping',
    add: i18nKo ? '담기' : 'ADD',
    added: '✓'
  };

  function log() {
    if (CONFIG.debug && window.console) console.log.apply(console, ['[filler]'].concat([].slice.call(arguments)));
  }

  function waitForZipManager(cb, attempts) {
    attempts = attempts || 0;
    if (window.ChefBanchan && window.ChefBanchan.ZipCodeManager) return cb(window.ChefBanchan.ZipCodeManager);
    if (attempts > 60) return;
    setTimeout(function () { waitForZipManager(cb, attempts + 1); }, 100);
  }

  waitForZipManager(function (ZipManager) {
    var productPool = null;
    var poolSource = null;
    var cartState = null;
    var updating = false;
    var renderQueued = false;

    // ===== 상품 후보 로드 (v1.5: 빈 배열은 캐시 안 함) =====
    function loadPool() {
      if (productPool && productPool.length) return Promise.resolve(productPool);
      return fetch('/collections/' + CONFIG.collectionHandle + '/products.json?limit=50')
        .then(function (r) { if (!r.ok) throw new Error('no collection'); return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) throw new Error('empty collection');
          var pool = data.products.map(normalizeCollectionProduct).filter(Boolean);
          if (pool.length) { productPool = pool; poolSource = 'collection'; }
          log('pool from collection', pool.length);
          return pool;
        })
        .catch(function () {
          var pid = cartState && cartState.items.length ? cartState.items[0].product_id : null;
          if (!pid) return [];
          return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (data) {
              var pool = (data.products || []).map(normalizeRecommendationProduct).filter(Boolean);
              poolSource = 'recommendations';
              log('pool from recommendations', pool.length);
              return pool;
            })
            .catch(function () { return []; });
        });
    }

    function normalizeCollectionProduct(p) {
      var v = (p.variants || [])[0];
      if (!v) return null;
      return {
        productId: p.id,
        variantId: v.id,
        title: p.title,
        price: parseFloat(v.price),
        available: v.available !== false,
        image: (p.images && p.images[0] && p.images[0].src) || null,
        url: '/products/' + p.handle
      };
    }

    function normalizeRecommendationProduct(p) {
      var vid = p.variants && p.variants[0] ? p.variants[0].id : null;
      if (!vid) return null;
      return {
        productId: p.id,
        variantId: vid,
        title: p.title,
        price: (typeof p.price === 'number' ? p.price / 100 : parseFloat(p.price)),
        available: p.available !== false,
        image: p.featured_image || null,
        url: p.url
      };
    }

    function fetchCart() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { cartState = cart; return cart; });
    }

    function getProgress() {
      var zip = ZipManager.getCurrentZipCode();
      var total = cartState ? cartState.total_price / 100 : 0;
      return ZipManager.calculateShippingProgress(total, zip);
    }

    // 추천 행 위치: 드로어=.mini-cart__main 맨 아래 / 카트페이지=.free-shipping-progress 아래 / 폴백=#bc-drawer-ship
    function getMounts() {
      var mounts = [];
      var main = document.querySelector('.mini-cart__main');
      if (main) mounts.push({ host: main, append: true });
      var cartProg = document.querySelector('.free-shipping-progress');
      if (cartProg) mounts.push({ host: cartProg, append: false });
      if (!mounts.length) {
        var ship = document.getElementById('bc-drawer-ship');
        if (ship) mounts.push({ host: ship, append: false });
      }
      return mounts;
    }

    function removeRows() {
      [].slice.call(document.querySelectorAll('.' + CONFIG.rowId)).forEach(function (el) { el.remove(); });
    }

    function money(n) {
      return '$' + n.toFixed(2).replace(/\.00$/, '');
    }

    function render() {
      if (updating) { renderQueued = true; return; }
      updating = true;

      fetchCart()
        .then(function () { return loadPool(); })
        .then(function (pool) {
          var progress = getProgress();
          var remaining = progress.remaining;

          if (progress.achieved || remaining < CONFIG.minRemaining || !cartState.item_count) {
            removeRows();
            return;
          }

          var inCart = {};
          cartState.items.forEach(function (it) { inCart[it.product_id] = true; });

          var candidates = pool.filter(function (p) {
            return p.available && !inCart[p.productId] && p.price > 0 && p.price <= remaining + 0.001;
          }).slice(0, CONFIG.maxItems);

          if (!candidates.length) {
            candidates = pool.filter(function (p) { return p.available && !inCart[p.productId]; })
              .sort(function (a, b) { return a.price - b.price; })
              .slice(0, 2);
          }
          if (!candidates.length) { removeRows(); return; }

          getMounts().forEach(function (m) {
            if (m.append) m.host.classList.add('bc-main-flex'); // 상품목록 flex화 → 추천 행 바닥 밀착
            var scope = m.append ? m.host : m.host.parentElement;
            var row = scope.querySelector('.' + CONFIG.rowId);
            var html = buildRowHTML(candidates, remaining);
            if (row) {
              row.innerHTML = html;
            } else {
              row = document.createElement('div');
              row.className = CONFIG.rowId;
              row.innerHTML = html;
              if (m.append) m.host.appendChild(row);
              else m.host.insertAdjacentElement('afterend', row);
            }
            bindRow(row);
          });
        })
        .catch(function (e) { log('render error', e); })
        .then(function () {
          updating = false;
          if (renderQueued) { renderQueued = false; setTimeout(render, 100); }
        });
    }

    function buildRowHTML(items, remaining) {
      var cards = items.map(function (p) {
        return (
          '<div class="bc-filler-card" data-variant="' + p.variantId + '">' +
            '<div class="bc-filler-media">' +
              (p.image
                ? '<img class="bc-filler-img" loading="lazy" src="' + sized(p.image, 200) + '" alt="">'
                : '<div class="bc-filler-img bc-filler-img--empty"></div>') +
              '<button type="button" class="bc-filler-add" data-variant="' + p.variantId + '" aria-label="Add ' + escapeHtml(p.title) + '">+</button>' +
            '</div>' +
            '<div class="bc-filler-title">' + escapeHtml(p.title) + '</div>' +
            '<div class="bc-filler-price">' + money(p.price) + '</div>' +
          '</div>'
        );
      }).join('');
      return (
        '<div class="bc-filler-head">' + TEXT.title + '</div>' +
        '<div class="bc-filler-scroll">' + cards + '</div>'
      );
    }

    function sized(src, w) {
      try {
        if (src.indexOf('?') > -1) return src + '&width=' + w;
        return src + '?width=' + w;
      } catch (e) { return src; }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function bindRow(row) {
      [].slice.call(row.querySelectorAll('.bc-filler-add')).forEach(function (btn) {
        if (btn.__bcBound) return;
        btn.__bcBound = true;
        btn.addEventListener('click', function () {
          var vid = btn.getAttribute('data-variant');
          btn.disabled = true;
          btn.textContent = '…';
          var mc = document.getElementById('mini-cart');
          var useSections = mc && typeof mc.renderContents === 'function';
          var body = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
          if (useSections) {
            body.sections = 'mini-cart,cart-icon-bubble,mobile-cart-icon-bubble';
            body.sections_url = window.location.pathname;
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function (parsed) {
              btn.textContent = TEXT.added;
              if (useSections && parsed.sections) {
                mc.renderContents(parsed);
                if (window.bcDrawerShip) setTimeout(window.bcDrawerShip, 120);
                setTimeout(render, 300);
              } else {
                refreshCartUI();
              }
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = '+';
            });
        });
      });
    }

    function refreshCartUI() {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.bcDrawerShip) setTimeout(window.bcDrawerShip, 150);
      setTimeout(render, 300);
    }

    // ===== 트리거 =====
    ['cart:updated', 'cartUpdated', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { setTimeout(render, 200); });
    });
    window.addEventListener('chefBanchanZipCodeChanged', function () { setTimeout(render, 200); });
    document.addEventListener('cartdrawer:opened', function () { render(); });
    loadPool();

    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var result = origFetch.apply(this, args);
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          result.then(function () { setTimeout(render, 350); }).catch(function () {});
        }
      } catch (e) { /* noop */ }
      return result;
    };

    var drawerEl = document.querySelector('cart-drawer, mini-cart');
    if (drawerEl) {
      new MutationObserver(function () { setTimeout(render, 150); })
        .observe(drawerEl, { attributes: true, attributeFilter: ['class', 'open'] });
      var moDebounce = null;
      new MutationObserver(function () {
        if (document.querySelector('.' + CONFIG.rowId)) return;
        clearTimeout(moDebounce);
        moDebounce = setTimeout(function () {
          if (window.bcDrawerShip) window.bcDrawerShip();
          render();
        }, 120);
      }).observe(drawerEl, { childList: true, subtree: true });
    }

    setInterval(function () {
      if (getMounts().length && !document.querySelector('.' + CONFIG.rowId)) {
        if (window.bcDrawerShip) window.bcDrawerShip();
        render();
      }
    }, 5000);

    setTimeout(render, 150);
  });
})();
